import { Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import * as util from '../../../../utils/Util';
import ErrorAwareBankAccountField from '../../../common/inputfields/ErrorAwareBankAccountField';
import ErrorAwareTaxNumberField from '../../../common/inputfields/ErrorAwareTaxNumberField';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';

class NewCustomer extends Component {

    state = {
        newAgain: false,
        selectedType: enums.partnerForBillTypes[0],
        name: '',
        bankAccountNumber: '',
        address: '',
        comment: '',
        taxNumber: '',
        errors: new Map(),
    };

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedType: enums.partnerForBillTypes[0],
            name: '',
            bankAccountNumber: '',
            address: '',
            comment: '',
            taxNumber: '',
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/customer';
        const requestObject = {
            "name": this.state.name,
            "type": this.state.selectedType.value,
            "bankAccountNumbers": this.getBankAccountNumber(),
            "address": this.state.address,
            "comment": this.state.comment,
            "taxNumber": this.state.taxNumber,
        };
        await handlePost(path, requestObject, this);
    };

    getBankAccountNumber = () => {
        let b = util.trimSpaces(this.state.bankAccountNumber)
        if (b) {
            return new Array(b);
        } else {
            return [];
        }
    }

    handle = (e) => {
        console.log(e);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="name"
                            label="Partner neve"
                            errors={this.state.errors}
                            value={this.state.name}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <FormControl variant="outlined" fullWidth required>
                            <InputLabel id="partner-type-label">Partner típusa</InputLabel>
                            <Select
                                name="selectedType"
                                labelId="partner-type-label"
                                id={this.props.name}
                                value={this.state.selectedType}
                                onChange={e => handleChangeEvent(e, this)}
                                label="Partner típusa">
                                {enums.partnerForBillTypes.map((value, index) =>
                                    <MenuItem key={index} value={value}>{value.label}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </div>
                    <div className='input-group'>
                        <ErrorAwareBankAccountField
                            name="bankAccountNumber"
                            label="Bankszámlaszám"
                            errors={this.state.errors}
                            value={this.state.bankAccountNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTaxNumberField
                            name="taxNumber"
                            label="Adószám"
                            errors={this.state.errors}
                            value={this.state.taxNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="address"
                            label="Cím"
                            errors={this.state.errors}
                            value={this.state.address}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewCustomer);
